"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_1 = require("./styled");
var InputField = function (_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (react_1.default.createElement(styled_1.Container, { className: "gray0-bg " + className },
        react_1.default.createElement("input", tslib_1.__assign({ className: "highlight" }, props))));
};
InputField.defaultProps = {
    placeholder: 'Menu Name...',
};
exports.default = InputField;
//# sourceMappingURL=index.js.map